"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPromise = void 0;
exports.isPromise = (value) => value instanceof Promise;
//# sourceMappingURL=is-promise.js.map